module.exports = __webpack_public_path__ + "static/media/ic_apartmentbarcelona.17864ea1.png";